import type {RefObject} from 'react';
import {twMerge} from 'tailwind-merge';
import type {Map as MapboxMap} from 'mapbox-gl';
import type {MyList} from 'server/apiHandlers/getMyListsHandler';
import MapAttribution from './MapAttribution';
import MapPlaceCard from './MapPlaceCard';

type Props = {
  places?: Partial<Place>[];
  reviews?: Review[];
  myLists: MyList[];
  mapContainer: RefObject<HTMLDivElement | null>;
  className?: string | string[];
  wrapperClassName?: string;
  mapViewClassName?: string;
  session: IronSession | null;
  hideAttribution?: boolean;
  map: MapboxMap | null;
};

const MapView = ({
  places,
  reviews,
  myLists,
  mapContainer,
  className,
  wrapperClassName,
  mapViewClassName,
  session,
  hideAttribution,
  map
}: Props) => {
  return (
    <div
      className={twMerge(
        'w-0 grow shrink-0 mb-6 max-[800px]:mb-0 sticky max-[800px]:left-0 flex flex-col items-center max-[800px]:top-[80px] z-4 bg-(--page-background)',
        className
      )}
    >
      <div
        className={twMerge(
          'rounded-2xl overflow-hidden w-full h-full bg-[rgb(250,250,250)] dark:bg-[rgb(12,5,15)] relative',
          wrapperClassName
        )}
      >
        <div
          ref={mapContainer}
          className={twMerge(
            'map-view h-full w-full after:shadow-[inset_0_0_0_1px_rgba(0,0,0,0.04)] dark:after:shadow-[inset_0_0_0_1px_rgba(255,255,255,0.15)] after:absolute after:top-0 after:left-0 after:w-full after:h-full after:rounded-2xl after:content-[""] after:pointer-events-none transition-opacity duration-300',
            map ? 'opacity-100' : 'opacity-0',
            mapViewClassName
          )}
        />

        {hideAttribution ? null : <MapAttribution />}
      </div>

      <MapPlaceCard places={places || []} reviews={reviews} myLists={myLists} session={session} map={map} />
    </div>
  );
};

export default MapView;
